// extracted by mini-css-extract-plugin
export default {"other":"other__NDBjM","password":"password__ZjczZ","footer":"footer__MThiY","footerText":"footerText__MTAzY","forgot":"forgot__MTNiM"};